import React from 'react';

interface VideoModalProps {
    isOpen: boolean;
    onClose: () => void;
    videoId?: string;
    title?: string;
}

const VideoModal: React.FC<VideoModalProps> = ({ isOpen, onClose, videoId = 'dQw4w9WgXcQ', title = 'Demo Video' }) => {
    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50"
            onClick={onClose}
        >
            <div
                className="w-4/5 max-w-3xl bg-white rounded-lg p-5 relative"
                onClick={e => e.stopPropagation()}
            >
                <button
                    className="absolute top-3 right-3 bg-transparent border-none text-2xl cursor-pointer hover:text-gray-700 transition-colors"
                    onClick={onClose}
                    aria-label="Close"
                >
                    ×
                </button>
                <div className="relative pt-[56.25%]">
                    <iframe
                        className="absolute top-0 left-0 w-full h-full border-0"
                        src={`https://www.youtube.com/embed/${videoId}`}
                        title={title}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
            </div>
        </div>
    );
};

export default VideoModal; 